// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__2yAGS","container":"styles_container__N81QA","title":"styles_title__3tWBs","wrapper":"styles_wrapper__2vbm2","answer":"styles_answer__2BcOh"};